import {BaseService} from '../baseService.js';

/* 
 * Handles Tracotors
 */
export class TractorService extends BaseService {

	constructor() {	
		super();
	}
	
	async getTractors(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/tractors' + params);
		return data;
	}	

	exportTractors(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/tractors/export' + params);		
	};

	async getTractor(tractorId) {
		var data = await this.makeGETRequest('/api/resource/tractors/' + tractorId);		
		return data;		
	}	
	
	async getTractorHistory(tractorId) {
		var data = await this.makeGETRequest('/api/resource/tractors/' + tractorId + '/history');		
		return data;		
	}		
	
	async getTractorHistoryDetail(tractorId, historyId) {
		var data = await this.makeGETRequest('/api/resource/tractors/' + tractorId + '/history/' + historyId + '/detail');		
		return data;		
	}	
	
	async saveTractor(tractor, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/tractors/' + tractor.tractorId, tractor);
		} else {
			saved = await this.makePOSTRequest('/api/resource/tractors', tractor);
		}
		return saved;
	}	

	async activateTractor(tractorId) {	
		var result = await this.makePUTRequest('/api/resource/tractors/' + tractorId + '/activate');
		return result;
	}	

	async inactivateTractor(tractorId) {	
		var result = await this.makePUTRequest('/api/resource/tractors/' + tractorId + '/inactivate');
		return result;
	}	
	
	async activateTractors(tractorIds) {	
		var result = await this.makePUTRequest('/api/resource/tractors/activate', tractorIds);
		return result;
	}	

	async inactivateTractors(tractorIds) {	
		var result = await this.makePUTRequest('/api/resource/tractors/inactivate', tractorIds);
		return result;
	}
	
	async flagTractor(flagRequest) {	
		var result = await this.makePUTRequest('/api/resource/tractors/flag', flagRequest);
		return result;
	}	
	
	//[Multi-ref]
	async getTractorMultiRefs(tractorId) {		
		var result = await this.makeGETRequest('/api/resource/tractors/' + tractorId + "/references");		
		return result;
	}	
	
	async getTractorMultiRef(tractorId, referenceId) {		
		var result = await this.makeGETRequest('/api/resource/tractors/' + tractorId + "/references/" + referenceId);		
		return result;
	}	
	
	async saveTractorMultiRef(tractorMultiRef, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/tractors/' + tractorMultiRef.tractorId +  '/references/' + tractorMultiRef.multiReferenceId, tractorMultiRef);
		} else {
			saved = await this.makePOSTRequest('/api/resource/tractors/' + tractorMultiRef.tractorId +  '/references', tractorMultiRef);
		}
		return saved;
	}	
	
	async deleteTractorMultiRef(tractorId, referenceId) {		
		var result = await this.makeDELETERequest('/api/resource/tractors/' + tractorId + "/references/" + referenceId);		
		return result;
	}
	
	//[Out of Authority]	
	async getTractorOOAs(tractorId) {		
		var result = await this.makeGETRequest('/api/resource/tractors/' + tractorId + "/out-of-authority");		
		return result;
	}	
	
	async getTractorOOA(tractorId, outOfAuthorityId) {		
		var result = await this.makeGETRequest('/api/resource/tractors/' + tractorId + "/out-of-authority/" + outOfAuthorityId);		
		return result;
	}	
	
	async saveTractorOOA(tractorOOA, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/tractors/' + tractorOOA.tractorId +  '/out-of-authority/' + tractorOOA.outOfAuthorityId, tractorOOA);
		} else {
			saved = await this.makePOSTRequest('/api/resource/tractors/' + tractorOOA.tractorId +  '/out-of-authority', tractorOOA);
		}
		return saved;
	}	
	
	async deleteTractorOOA(tractorId, outOfAuthorityId) {		
		var result = await this.makeDELETERequest('/api/resource/tractors/' + tractorId + "/out-of-authority/" + outOfAuthorityId);		
		return result;
	}
	
	//[Jurisdiction]	
	async getTractorJurisdictions(tractorId) {		
		var result = await this.makeGETRequest('/api/resource/tractors/' + tractorId + "/jurisdictions");		
		return result;
	}	
	
	async getTractorJurisdiction(tractorId, jurisdictionId) {		
		var result = await this.makeGETRequest('/api/resource/tractors/' + tractorId + "/jurisdictions/" + jurisdictionId);		
		return result;
	}	
	
	async saveTractorJurisdiction(tractorJuris, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/tractors/' + tractorJuris.tractorId +  '/jurisdictions/' + tractorJuris.jurisdictionId, tractorJuris);
		} else {
			saved = await this.makePOSTRequest('/api/resource/tractors/' + tractorJuris.tractorId +  '/jurisdictions', tractorJuris);
		}
		return saved;
	}	
	
	async deleteTractorJurisdiction(tractorId, jurisdictionId) {		
		var result = await this.makeDELETERequest('/api/resource/tractors/' + tractorId + "/jurisdictions/" + jurisdictionId);		
		return result;
	}	
	
	//[mpg overrides]	
	async getTractorMpgOverrides(tractorId) {		
		var result = await this.makeGETRequest('/api/resource/tractors/' + tractorId + "/mpg-overrides");		
		return result;
	}	
	
	async getTractorMpgOverride(tractorId, mpgOverrideId) {		
		var result = await this.makeGETRequest('/api/resource/tractors/' + tractorId + "/mpg-overrides/" + mpgOverrideId);		
		return result;
	}	
	
	async saveTractorMpgOverrides(mpgOverride, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/tractors/' + mpgOverride.tractorId +  '/mpg-overrides/' + mpgOverride.mpgOverrideId, mpgOverride);
		} else {
			saved = await this.makePOSTRequest('/api/resource/tractors/' + mpgOverride.tractorId +  '/mpg-overrides', mpgOverride);
		}
		return saved;
	}	
	
	async deleteTractorMpgOverrides(tractorId, mpgOverrideId) {		
		var result = await this.makeDELETERequest('/api/resource/tractors/' + tractorId + "/mpg-overrides/" + mpgOverrideId);		
		return result;
	}	
	
};

